/**
 * Combsol Headline-Duo — Spec §2.3
 * Zwei Zeilen, Row-1 Navy (#002D72), Row-2 Combsol-Blau (#00A3E0).
 * line-height .92, Montserrat 900. Verwendung: Hero, Section-Heads, Empty-States.
 */
import type { CSSProperties, ReactNode } from "react";

type Size = "xl" | "lg" | "md";

interface Props {
  rowOne: ReactNode;
  rowTwo: ReactNode;
  size?: Size;
  onDark?: boolean;
  className?: string;
  style?: CSSProperties;
}

const SIZE: Record<Size, { fs: string; fw: number }> = {
  xl: { fs: "clamp(3rem, 6vw, 5.5rem)",   fw: 900 },
  lg: { fs: "clamp(2.2rem, 4vw, 3.5rem)", fw: 800 },
  md: { fs: "clamp(1.5rem, 2.5vw, 2rem)", fw: 800 },
};

export function HeadlineDuo({ rowOne, rowTwo, size = "lg", onDark = false, className = "", style }: Props) {
  const s = SIZE[size];
  const row1Color = onDark ? "#E6F6FD" : "var(--color-brand-navy, #002D72)";
  const row2Color = "var(--color-brand-blue, #00A3E0)";
  return (
    <div
      className={className}
      style={{
        fontFamily: "var(--font-display, 'Montserrat', sans-serif)",
        fontWeight: s.fw,
        fontSize: s.fs,
        lineHeight: 0.92,
        letterSpacing: "-0.025em",
        ...style,
      }}
    >
      <span style={{ display: "block", color: row1Color }}>{rowOne}</span>
      <span style={{ display: "block", color: row2Color }}>{rowTwo}</span>
    </div>
  );
}
